import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  metaDataContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  updateRow: {
    display: 'flex',
    padding: theme.spacing(1, 0),
  },
  textField: {
    width: '211px',
    marginRight: theme.spacing(3),
    '& .MuiInputBase-input': {
      fontSize: '13px',
      color: theme.palette.black.main,
      textAlign: 'left',
    },
    '& .MuiInputLabel-root': {
      fontSize: '13px',
      color: theme.palette.primary.light,
      fontWeight: 600,
    },
    '& .MuiFormHelperText-root.Mui-error': {
      fontSize: '11px',
      color: `${theme.palette.error.main} !important`,
    },
    '& .MuiFormLabel-asterisk.MuiInputLabel-asterisk': {
      color: theme.palette.requiredAsterisk.main,
    },
  },
  closeIconButton: {
    padding: theme.spacing(0),
    margin: theme.spacing(-2.5, 0, -3, 2.812),
    alignSelf: 'center',
  },
  closeIcon: {
    '&.MuiSvgIcon-root': {
      width: '20px',
      height: '20px',
      color: theme.palette.icon.main,
    },
  },
  infoIcon: {
    color: theme.palette.icon.main,
    '&.MuiSvgIcon-root': {
      height: '16px',
      width: '16px',
    },
  },
}))
